export default __webpack_public_path__ + "static/media/arrowRightLavander.6dc9ef5d.svg";